export default __webpack_public_path__ + "static/media/SphereCoreCorrespondence.74e20539.webp";